import { ReceiptPayload } from 'flows/core/types/cards';
import { StreamCardLegacy as StreamCard } from '../common/stream-card';

export type BasicReceiptCardProps = ReceiptPayload & {
  actionTracker?: () => void | undefined;
  showSubtitle?: boolean;
};

export const BasicReceiptCard: React.FC<BasicReceiptCardProps> = ({
  data,
  identifier,
  type,
  actionTracker,
  showSubtitle = false,
  // importanceScore,
}) => {
  if (data.subtype !== 'BASIC') return null;
  const { heading, badge, action, description, descriptionLine2, subtitle } =
    data;
  return (
    <StreamCard
      identifier={identifier}
      cardType={type}
      heading={heading ?? ''}
      description={description}
      descriptionLine2={descriptionLine2}
      subtitle={showSubtitle ? subtitle : ''}
      badge={badge}
      action={action}
      actionTracker={actionTracker}
    />
  );
};
